import ScrollButton from "../components/scroll_button";
import Layout from "../components/layout";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import styles from "../styles/confidential-computing.module.scss";
import StartBusiness from "../components/startBusiness";
import { benefitsList, confidentialReasonsList, keyCapabilitiesList } from "../constants/confidential-computing";
import VmsIcon from "../public/services/confidential-computing/icons/vms.svg";
import GpuIcon from "../public/services/confidential-computing/icons/gpu.svg";
import Image from 'next/image';
import ExpandedList from "../components/expandedList";
import InfoSection from "../components/info_section";

const benefitsIcons = {
    vms: VmsIcon,
    gpu: GpuIcon,
}

export default function ConfidentialComputing() {
    const router = useRouter();
    const { t } = useTranslation("confidential-computing");

    return (
        <Layout
            title={t("title")}
            lang={router.locale}
            route={router.route}
            isHeader
            isFooter
        >
            <ScrollButton scrollStepInPx="50" delayInMs="16.66" />
            <InfoSection
                title={t("confidentialComputingTitle")}
                description="confidentialComputingDescription"
                lang={router.locale}
                contactButton
            />

            <section className={styles.confidentialComputing}>
                <div className={styles.confidentialComputing__item}>
                    <div>
                        <h2>{t("benefits.title")}</h2>
                    </div>
                    <div className={styles.benefits}>
                        {benefitsList.map((item, index) => (
                            <div key={index} className={styles.benefits__item}>
                                <Image src={benefitsIcons[item.iconUrl]} alt={item.title} />
                                <h3>{t(item.title)}</h3>
                                <p>{t(item.description)}</p>
                            </div>
                        ))}
                    </div>

                </div>
                <div className={styles.confidentialComputing__item}>
                    <div><h2>{t("keyCapabilities.title")}</h2></div>
                    <div>
                        <ExpandedList data={keyCapabilitiesList.map(item => ({ title: t(item.title), description: t(item.description) }))} />
                    </div>

                </div>
                <div className={styles.confidentialComputing__item}>
                    <div><h2>{t("confidentialReasons.title")}</h2></div>
                    <div>
                        <ExpandedList data={confidentialReasonsList.map(item => ({ title: t(item.title), description: t(item.description) }))} />
                    </div>
                </div>
            </section>

            <StartBusiness />
        </Layout>
    );
}

export const getStaticProps = async ({ locale }) => ({
    props: {
        ...(await serverSideTranslations(locale, ["confidential-computing", "common"])),
    },
});
